import React from "react";
import PropTypes from "prop-types";
import styles from "./FilterCheckList.module.css";
import CheckListItem from "../CheckListItem";
import CheckList from "../CheckList";

/**
 * A list of checklists that allows the feed list to be filtered by certain conditions / categories.
 */
export function FilterCheckList({
  filterOptions,
  checkedOptions,
  setCheckedOptions,
}) {
  return (
    <div>
      {filterOptions.map((option, index) => (
        <div
          key={option.categoryTitle} // Add key
          className={index == 0 ? "" : styles.border}
        >
          <CheckList
            categoryTitle={option.categoryTitle}
            categoryOptions={option.categoryOptions}
            checkedOptions={checkedOptions}
            setCheckedOptions={setCheckedOptions}
          />
        </div>
      ))}
    </div>
  );
}


FilterCheckList.propTypes = {
  // /**
  //  * An array of the feed filter check lists.
  //  */
  // filterOptions: PropTypes.string,
  // /**
  //  * Stores the values of currently checked checkboxes. All options are contained in this list regardless of category.
  //  */
  // checkedOptions: PropTypes.string,
  // /**
  //  * Function that sets the value of the checked options.
  //  */
  // setCheckedOptions: PropTypes.string,

  // Clean up PropTypes
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      categoryTitle: PropTypes.string.isRequired,
      categoryOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
  checkedOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setCheckedOptions: PropTypes.func.isRequired,
};
